import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { getHistoryNew } from '@utils'
import { favoMobx } from 'mobx/mall'
import { decorationMobx } from '@mobxStore'
import { MallController } from '@ctrls/mallController'
import './index.scss'
import { Icon } from '@cps'
import ShopCartBar from '../ShopCartBar'

const CollectWrap: React.FC = () => {
  const history = getHistoryNew()
  const { mallGlobalDecorates: { collect } } = decorationMobx
  return (
    <div className='favorite-wrap'>
      <Icon name='search1' data-cypid='mall-search' onClick={() => history.push('/msearch')} />
      <Icon name='mcollect' data-cypid='mall-collect' onClick={() => history.push('/mcollect')} />
      <ShopCartBar />
    </div>
  )
}

export default observer(CollectWrap)
